/**
 * Copyright (c) 2021 MeetOnline.IO
 *
 * long description for the file
 *
 * @summary INDEX.js INIT FILE
 * @author Rishabh <rishabh.it.007@gmail.com>
 *
 * Created at     : 2021-02-26 12:00:00
 * Last modified  : 2021-02-26 12:00:00
 */
import "./index.css"
import { ChakraProvider, extendTheme } from "@chakra-ui/react"
import React from "react"
import ReactDOM from "react-dom"
import { RecoilRoot } from "recoil"
import "./i18n"
import App from "./components/app"
import { SDKContextProvider } from "./context/SDKContext"
import { MeetClientHandlerProvider } from "./context/MeetClientHandler"
import reportWebVitals from "./util/reportWebVitals"
import { ConsoleLogger } from "../src/util/logger"
import "@fontsource/rubik/700.css"
import "@fontsource/poppins/700.css"
import { BrowserRouter } from "react-router-dom"
import { QueryClientProvider } from "react-query"
import { Toaster } from "react-hot-toast"
import { queryClient } from "./shared/queryClient"
import { MathJaxContext } from "better-react-mathjax"

const logger = new ConsoleLogger()
logger.log("process.env.PUBLIC_URL => " + import.meta.env.PUBLIC_URL)
logger.log(
  "process.env.REACT_APP_SDK_URL => " +
    import.meta.env.REACT_APP_SDK_URL +
    "/mo.sdk.js?r=h2s9o4"
)
logger.log("process.env.NODE_ENV => " + import.meta.env.NODE_ENV)
logger.log("process.env.REACT_APP_STAGE => " + import.meta.env.REACT_APP_STAGE)

const theme = extendTheme({
  textStyles: {},
  fonts: {
    Rubik: `'Rubik', sans-serif`,
    Poppins: `'Poppins', sans-serif`
  },
  breakpoints: {
    "2xl": "1605px" // 1605px
  }
})

ReactDOM.render(
  // <React.StrictMode>
  <RecoilRoot>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={theme}>
          <SDKContextProvider>
            <MeetClientHandlerProvider>
              <MathJaxContext>
                <App />
                <Toaster position="bottom-right" />
              </MathJaxContext>
            </MeetClientHandlerProvider>
          </SDKContextProvider>
        </ChakraProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </RecoilRoot>,
  // </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
